import { Fab } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import React, { FC } from 'react';

import { Layout } from './Layout';
import { Message, MessageType } from './Message';
import messages from './messages';
import useStyles from './styles';

export interface ErrorStateProps {
  message?: MessageType;
  onClick?: () => void;
}
export const ErrorState: FC<ErrorStateProps> = ({ message = '', onClick = () => {} }) => {
  const styles = useStyles();

  const text = message ? <Message message={message} /> : <Message definedMessage={messages.error} />;

  const action = (
    <Fab className={styles.refreshButton} color="primary" onClick={onClick} size="small">
      <RefreshIcon />
    </Fab>
  );

  return <Layout nodes={[text, action]} />;
};
